<template>
    <div>
        <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'">
            {{ $tt('Extension de garantie') }}
        </h1>
        <sav-fold-card
        v-model="open"
        class="mt-4"
        :close-button="false"
        :id="$options.name"
        :can-open="canOpen"
        >
            <template v-slot:close>
                <span class="font-bold" v-if="selected">
                    <template v-if="selected.exists <= 0">
                        {{ $tt("Ne possède pas d'extension de garantie") }}
                    </template>
                    <template v-else>
                        <div>{{ $tt("Numéro de garantie") }} : {{ selected['number'] }}</div>
                        <div>{{ $tt("Fichier") }} : <a @click.stop="null" target="_blank" class="hover:underline text-blue-500" :href="selected['file'].url">{{ $tt("Consulter le fichier") }}</a></div>
                    </template>
                </span>
            </template>

            <template v-slot:open>
                <div class="font-light text-slate-900">
                    <div>{{ $t('form.garantie.possedez_vous_une_extension_de_garantie_?') }}</div>
                    <div class="flex gap-2 mt-2">
                        <button @click="hasExtensionGarantie = true" class="px-4 py-1 duration-200 cursor-pointer rounded" :class="hasExtensionGarantie ? 'bg-slate-800 text-white' : 'bg-green-200 hover:bg-green-300'">{{ $t('form.garantie.oui') }} <i class="fas fa-check ml-1"></i></button>
                        <button @click="hasExtensionGarantie = false; end({exists: false})" class="px-4 py-1 duration-200 cursor-pointer rounded" :class="hasExtensionGarantie ? 'bg-slate-100 hover:bg-red-200' : 'bg-red-200 hover:bg-red-300'">{{ $t('form.garantie.non') }} <i class="fas fa-times ml-1"></i></button>
                    </div>
                    <div class="mt-4 bg-slate-100 p-4 rounded-xl border" v-if="hasExtensionGarantie">
                        <sav-input v-model="extensionNumber" class="mb-4" type="text" :label="$t('form.garantie.quel_est_votre_numero_d_extension_de_garantie_?')" />
                        <sav-input v-model="extensionFile" type="file" :label="$t('form.garantie.justificatif')" />
                        <button @click="addExtensionGarantie" class="mt-4 px-4 py-2 duration-200 cursor-pointer rounded bg-green-500 text-white">{{ $t('form.garantie.valider') }} <i class="fas fa-check ml-1"></i></button>
                    </div>
                </div>
            </template>
        </sav-fold-card>
    </div>
</template>

<script>
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'extension-warranty',
    extends: FormCardExtension,

    data() {
        return {
            hasExtensionGarantie: false,
            extensionNumber: null,
            extensionFile: null
        }
    },

    methods: {
        init() {
            this.loading = true

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.nextBlock = this.$formTool.blockData(this.$options.name).next
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            this.loading = false
        },

        end(callbackData) {
            this.$formTool.addFormData(this.$options.name, callbackData)
            this.nextBlock = this.$formTool.blockData(this.$options.name).next
            if (!callbackData.exists) {
                this.hasExtensionGarantie = false
                this.extensionNumber = null
                this.extensionFile = null
            }
            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
        },

        addExtensionGarantie() {
            if (this.extensionNumber && this.extensionFile) {
                let endData = {
                    'exists': true,
                    'number': this.extensionNumber,
                    'file': this.extensionFile,
                }
                this.$formTool.addFormData(this.$options.name, endData)
                this.nextBlock = this.$formTool.blockData(this.$options.name).next
                if (this.selected) {
                    this.$emit('update', this.$options.name)
                }
                this.selected = JSON.parse(JSON.stringify(endData))
            } else {
                this.$toast.error('Formulaire incomplet')
            }
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/warranty/ExtensionWarranty.vue